import layout from "~/layout/App/Index.vue";
import auth from "../middleware/auth";

const invitationRoutes = {
  path: "/invitation",
  component: layout,
  name: "invitation",
  meta: {
    middleware: auth
  },
  children: [
    {
      path: "",
      component: () => import("~/views/Invitation/Counterparties"),
      name: "invitation.counterparty",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'invitations', route: "invitation.counterparties" },
          { name: "name.counterparties" }
        ],
      }
    },
    {
      path: "contracts",
      component: () => import("~/views/Invitation/Contract"),
      name: "invitation.contracts",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'invitations', route: "invitation.counterparties" },
          { name: "name.contracts" }
        ],
      }
    },
    {
      path: "counterparties",
      component: () => import("~/views/Invitation/Counterparties"),
      name: "invitation.counterparties",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'invitations', route: "invitation.counterparties" },
          { name: "name.counterparties" }
        ],
      }
    }
  ]
};

export default invitationRoutes;
